import React from 'react';
import {Box, Text, VStack, HStack, Heading, Pressable} from 'native-base';
import {
  BolivarIcon,
  DollarIcon,
} from '../../../../../../../../components/icons';
import IInvoiceCandidate from '../../../../../../../../interfaces/dtos/invoice-candidate-list.interface';
import {formatMoney} from '../../../../../../../../utils/format';

interface ItemProps {
  onPress: () => void;
  rowType: 'odd' | 'even';
  item: IInvoiceCandidate;
}

const InvoiceCandidateListItem = (props: ItemProps) => {
  const {item, onPress, rowType} = props;
  const {document, info, amount, currency} = item;

  const handleOnPress = () => {
    onPress();
  };

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#FFFFFF';
    }
    return '#F3F9FF';
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}>
        <VStack flex={1}>
          <HStack space={5}>
            <VStack justifyContent="center" space="0" flex={1}>
              <Box height="5" justifyContent="center">
                <Heading size="sm" fontWeight="medium" color="black">
                  {document}
                </Heading>
              </Box>
              <Box height="5" justifyContent="center" marginTop={1}>
                <Text
                  color="#99A2B4"
                  fontSize={'sm'}
                  ellipsizeMode="tail"
                  numberOfLines={1}>
                  {info.terms}:{info.category}
                </Text>
              </Box>
            </VStack>
            <HStack w="120">
              <VStack justifyContent="center" space="1">
                {currency === 'BS' && (
                  <Box height="5" justifyContent="center">
                    <BolivarIcon />
                  </Box>
                )}
                {currency === 'USD' && (
                  <Box height="5" justifyContent="center">
                    <DollarIcon />
                  </Box>
                )}
              </VStack>
              <VStack justifyContent="center" space="1" w={'100'}>
                <Box height="5" alignItems={'flex-end'} paddingLeft="2">
                  <Text fontWeight="bold" color="#06355E">
                    {formatMoney(amount ?? -1, '')}
                  </Text>
                </Box>
              </VStack>
            </HStack>
          </HStack>
        </VStack>
      </HStack>
    </Pressable>
  );
};

export default InvoiceCandidateListItem;
